exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.agentWhiteListHolder .errorHolder[data-v-27da7c59] {\n  height: 1.5rem;\n}\n.agentWhiteListHolder .agentList[data-v-27da7c59] {\n  max-height: 450px;\n  overflow: auto;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-27da7c59","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/inventory/products/components/AgentWhiteList.vue
// module id = 1378
// module chunks = 0